import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Data from '../../../../components/auth/leis/listar/form_data'


function DataLeiScreen() {

    return (
        <Fragment>
            <Head titulo="Editando data da lei - Módulo Legislativo" />
            <HeaderLogged />
            <Container>
               <Data />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DataLeiScreen;